export default "__VITE_ASSET__DqSPzQU2__"